Apt.fn.extend('filters', {
	/**
	 * Submit form data
	 */
	submit() {
		const scope = this;
		const priv = scope.$private;

		if (! priv.serialize) {
			return;
		}

		priv.hideFilters();

		const data = priv.serialize();

		if ($.equals(scope.current, data) || ! LS.form.validate('$filters')) {
			return;
		}

		const diff = $.diff(scope.current, data);

		if (! diff.location || diff.location.type === '-') {
			const filters = LS.filters.get();

			Object.assign(data, LS.util.sanitize({
				bounds: filters.bounds,
				center: data.center || filters.center,
				geometry: filters.geometry,
				sync: filters.sync,
				zoom: data.zoom || filters.zoom
			}));
		}

		$.history.go({
			path: LS.filters.build('properties', data)
		});
	},

	/**
	 * Reset filters
	 *
	 * @param {Array|String} [targets]
	 */
	reset(targets) {
		const scope = this;
		const priv = scope.$private;

		if (targets) {
			$.toArray(targets)
				.forEach(target => {
					$.app.filters.$drop('input.' + target);
				});
		} else {
			const model = $.copy(priv.model);
			const sort = LS.filters.get('sort');

			if (sort) {
				model.sort = sort;
			}

			$.app.filters.$set(model);
		}

		const sync = Apt.properties.$private.sync;

		if (sync) {
			sync.disable(false);
		}

		priv.count($.app.filters.$get());

		scope.submit();
	}
}, {
	/**
	 * Bind button events
	 */
	bindButtons() {
		const scope = this;

		$$('filterApply').on('mousedown', () => {
			scope.hideFilters(true);
		}, {
			namespace: 'filters'
		});

		const map = {
			criteria: scope.criteria,
			more: scope.more,
			price: 'price',
			size: 'size'
		};

		$.events.on('$filterReset', 'click', (e, el) => {
			scope.$public.reset(map[el.dataset.target] || null);
		}, {
			delegate: '$filters',
			namespace: 'filters'
		});
	},

	/**
	 * Bind toggle events
	 */
	bindToggle() {
		const scope = this;

		$$('filterHeading').on('mousedown', (e, el) => {
			const id = el.dataset.id;

			if ($.app.filters.$get('active') === id) {
				scope.hideFilters(true);

				return;
			}

			scope.visibleFilter = $(el.parentNode);

			$.app.filters.$set('active', id);

			if ($.screen.size() < 5) {
				LS.util.crop();
			}

			document.body.classList.add('-is-filtered');

			// Set input focus on range selections
			if (el.dataset.type === 'range') {
				const input = $('input', el.nextElementSibling)[0];

				requestAnimationFrame(() => {
					input.value ?
						input.select() : input.focus();
				});
			}

			// Hide active filters on ESC press
			$(document).on('keyup', e => {
				if (e.keyCode === 27) {
					scope.hideFilters(true);
				}
			}, {
				cancel: true,
				namespace: 'activeFilter'
			});

			// Hide active filters when clicking outside container
			let inside;

			$(document.body).on({
				mousedown: e => {
					inside = $(e.target).closest(scope.visibleFilter).length;
				},
				mouseup: () => {
					if (inside) {
						return;
					}

					setTimeout(() => {
						if (scope.visibleFilter && LS.filters.isProperty()) {
							scope.hideFilters(
								! Apt.panel.opened() &&
								! $.history.pending()
							);
						}
					}, 100);
				}
			}, {
				namespace: 'activeFilter'
			});
		}, {
			namespace: 'filters'
		});
	},

	/**
	 * Bind filter form events
	 */
	bindForm() {
		const scope = this;

		$$('filters').on('submit', () => {
			scope.$public.submit();
		}, {
			cancel: true,
			namespace: 'filters'
		});
	}
});